import { render, staticRenderFns } from "./LiveStatusofBranches.vue?vue&type=template&id=19a07442&scoped=true&"
import script from "./LiveStatusofBranches.vue?vue&type=script&lang=js&"
export * from "./LiveStatusofBranches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a07442",
  null
  
)

export default component.exports